import { russianPlural } from "./russian-plural.mjs";
export default () => ({
	legacy: true,
	pluralRules: { ru: russianPlural }
});
